const finite = (value, fallback = 0) =>
  Number.isFinite(Number(value)) ? Number(value) : fallback;

export const clampPresentationZoom = (value) =>
  Math.min(200, Math.max(50, Math.round(finite(value, 100) / 10) * 10));

export const getContainedPresentationSize = ({
  viewportWidth,
  viewportHeight,
  contentWidth = 16,
  contentHeight = 9,
  zoomPercent = 100,
  padding = 24,
} = {}) => {
  const availableWidth = Math.max(1, finite(viewportWidth, 1) - Math.max(0, finite(padding, 24)));
  const availableHeight = Math.max(1, finite(viewportHeight, 1) - Math.max(0, finite(padding, 24)));
  const width = Math.max(1, finite(contentWidth, 16));
  const height = Math.max(1, finite(contentHeight, 9));
  const fitScale = Math.min(availableWidth / width, availableHeight / height);
  const zoomScale = clampPresentationZoom(zoomPercent) / 100;
  return {
    width: Math.max(1, Math.floor(width * fitScale * zoomScale)),
    height: Math.max(1, Math.floor(height * fitScale * zoomScale)),
    fitScale,
    zoomPercent: clampPresentationZoom(zoomPercent),
  };
};

